<div *ngIf="messageBody?.length" class="alert alert-success message-block" [ngClass]="{
  'alert-success': messageTitle == 'Success',
  'alert-danger': messageTitle == 'Failed',
  'alert-info': messageTitle == 'Information'
}">
  <button type="button" class="close-icon" (click)="closeMessage()">
      <span class="material-icons">close</span>
  </button>
  <strong>{{ messageTitle }}</strong>:
  <span class="mx-1">{{ messageBody }}</span>
</div>
<div class="appLayout workRequest">
  <!--  -->

  <div class="requestedlog">
    <!-- <div class="main">
    <div class="main1">
        <div class="tabval1" (click)="tabClick('NewReport')" [ngClass]="{'tabval2': tabVal=='NewReport'}">New Report </div>
        <div class="tabval1" (click)="tabClick('SavedReport')" [ngClass]="{'tabval2': tabVal=='SavedReport'}">Saved Report

        </div>
    </div>
  </div> -->
    <!-- <div class="clearFilterContainer">      
      <input type="number" [(ngModel)]="reportId" min="1" max="6"/>
      <button (click)="getSavedReports()" formtarget="_blank">Test</button>
      {{ reportId }}
    </div> -->
    <span class="title">List of Saved Reports</span>
    <div class="requestTable" style="margin-top: 20px !important;">
      <table mat-table [dataSource]="workRequestdataSource" class="mat-elevation-z8 queuesTable" matSort
        id="excel-table" #empTbSort="matSort">
        <ng-container matColumnDef="SavedReportName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Saved Report Name</th>
          <td mat-cell *matCellDef="let row">{{ row.SavedReportName }}</td>
        </ng-container>

        <ng-container matColumnDef="Comments">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Comments</th>
          <td mat-cell *matCellDef="let row">{{ row.Comments }}</td>
        </ng-container>

        <ng-container matColumnDef="SavedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Date and Time
          </th>
          <td mat-cell *matCellDef="let row">{{ row.SavedOn }}</td>
        </ng-container>

        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 8% !important">
            Actions
          </th>
          <td mat-cell *matCellDef="let row">
            <!-- <div mattooltip="Add" class="mat-tooltip-trigger filterButton ng-tns-c194-20 ng-star-inserted"
                                          ng-reflect-message="Add" aria-describedby="cdk-describedby-message-3"
                                          (click)="OnLoadReport(row.SavedReportId, row.SavedReportName, row.ReportId, row.ReportCode, row.ReportName, row.Parameters)" cdk-describedby-host="">
                                          Load Report
                                        </div> -->
            <div style="display: flex;justify-content: center;">
              <div>
                <i class="fa fa-list loadReport" matTooltip="Load Report"
                  (click)="OnLoadReport(row.SavedReportId, row.SavedReportName, row.ReportId, row.ReportCode, row.ReportName, row.Parameters)"></i>
              </div>
              <div style="padding-left: 15px;">
                <i class="fa fa-trash trash" matTooltip="Delete Report" (click)="DeleteFilter(row.SavedReportId)"></i>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="Delete">
          <th mat-header-cell *matHeaderCellDef mat-sort-header  style="width: 5% !important;">
            Delete
          </th>
          <td mat-cell *matCellDef="let row" style="text-align: center;">
            <mat-icon class="tableIcon" style="color: #b9251c" (click)="
                      DeleteFilter(row.SavedReportId)
                    " matTooltip="Delete">
                    close
            </mat-icon>
          </td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="savedReportsColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: savedReportsColumns"></tr>
      </table>
    </div>

    <!-- <div  *ngIf="tabVal=='NewReport'">      
     
      
    </div> -->
  </div>
</div>